import { render, staticRenderFns } from "./domainsList.vue?vue&type=template&id=e2a4400c&"
import script from "./domainsList.vue?vue&type=script&lang=js&"
export * from "./domainsList.vue?vue&type=script&lang=js&"
import style0 from "./domainsList.vue?vue&type=style&index=0&id=e2a4400c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports